var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"instruction"},[_c('instruction-header'),_c('instruction-body')],1)}
var staticRenderFns = []

export { render, staticRenderFns }